<template>
  <main-template>
    <v-row class="mb-2">
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="$router.go(-1)">
            <v-icon left>fa fa-angle-left</v-icon>
          </v-btn>
          {{ modoEdicao ? "Editar Justificativa em Massa" : "Nova Justificativa em Massa" }}
        </h1>
        <p class="body-2 ml-8 mb-0">
          {{
            modoEdicao
              ? "Atualize os dados da justificativa em massa."
              : "Registre uma justificativa para múltiplos colaboradores."
          }}
        </p>
      </v-col>
    </v-row>

    <v-card outlined>
      <v-card-title class="subtitle-1 font-weight-bold">Dados da justificativa</v-card-title>
      <v-divider />
      <v-card-text class="pt-5">
        <v-form ref="formRef">
          <v-row dense>
            <v-col cols="12" sm="6">
              <v-menu
                v-model="menuDataReferencia"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    :value="form.data_referencia ? formatarData(form.data_referencia) : ''"
                    label="Data de Referência *"
                    outlined
                    dense
                    readonly
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    :rules="[() => !!form.data_referencia || 'Data de referência obrigatória']"
                  />
                </template>
                <v-date-picker
                  v-model="form.data_referencia"
                  locale="pt-BR"
                  @input="menuDataReferencia = false"
                />
              </v-menu>
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="form.motivo"
                label="Motivo *"
                outlined
                dense
                rows="2"
                counter="500"
                :rules="[
                  (v) => !!v || 'Motivo obrigatório',
                  (v) => !v || v.length <= 500 || 'Máximo 500 caracteres',
                  validarTexto,
                ]"
              />
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="form.observacao"
                label="Observação (opcional)"
                outlined
                dense
                rows="2"
                counter="500"
                :rules="[(v) => !v || v.length <= 500 || 'Máximo 500 caracteres', validarTexto]"
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="form.colaborador_ids"
                :items="colaboradores"
                item-text="name"
                item-value="id"
                label="Colaboradores *"
                outlined
                dense
                multiple
                chips
                small-chips
                deletable-chips
                :loading="carregandoColaboradores"
                :rules="[(v) => (v && v.length > 0) || 'Selecione pelo menos um colaborador']"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider />
      <v-card-actions class="px-4 py-3">
        <v-spacer />
        <v-btn text :disabled="salvando" @click="$router.go(-1)">Cancelar</v-btn>
        <v-btn color="primary" :loading="salvando" @click="salvar">
          <v-icon left small>mdi-content-save</v-icon>
          {{ modoEdicao ? "Salvar Alterações" : "Criar Justificativa" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </main-template>
</template>

<script>
export default {
  name: "NovaJustificativaMassaPage",
  data() {
    return {
      salvando: false,
      carregandoColaboradores: false,
      modoEdicao: false,
      editarId: null,
      menuDataReferencia: false,
      colaboradores: [],
      form: {
        data_referencia: "",
        motivo: "",
        observacao: "",
        colaborador_ids: [],
      },
    };
  },
  async created() {
    const editarId = this.$route.query.editarId;
    await this.carregarColaboradores();
    if (editarId) {
      this.modoEdicao = true;
      this.editarId = editarId;
      await this.carregarParaEdicao(editarId);
    }
    if (this.$refs.formRef) this.$refs.formRef.resetValidation();
  },
  methods: {
    async carregarColaboradores() {
      try {
        this.carregandoColaboradores = true;
        this.colaboradores = await this.$services.colaboradorPontosService.listarColaboradores();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregandoColaboradores = false;
      }
    },
    async carregarParaEdicao(id) {
      try {
        const detalhe = await this.$services.colaboradorPontosService.buscarJustificativaMassa(id);
        this.form = {
          data_referencia: String(detalhe.data_referencia).split("T")[0],
          motivo: detalhe.motivo,
          observacao: detalhe.observacao || "",
          colaborador_ids: (detalhe.colaboradores || []).map((c) => c.id),
        };
      } catch (error) {
        this.$handleError(error);
        this.$router.go(-1);
      }
    },
    async salvar() {
      if (!this.$refs.formRef.validate()) return;

      try {
        this.salvando = true;
        if (this.modoEdicao) {
          await this.$services.colaboradorPontosService.atualizarJustificativaMassa(
            this.editarId,
            this.form
          );
          this.$toast.success("Justificativa em massa atualizada com sucesso!");
        } else {
          await this.$services.colaboradorPontosService.criarJustificativaMassa(this.form);
          this.$toast.success("Justificativa em massa criada com sucesso!");
        }
        this.$router.push({ name: "colaboradores.justificativaMassa" });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.salvando = false;
      }
    },
    formatarData(data) {
      if (!data) return "";
      const [ano, mes, dia] = String(data).split("T")[0].split("-");
      return `${dia}/${mes}/${ano}`;
    },
    validarTexto(v) {
      if (!v) return true;
      if (/\p{Emoji_Presentation}/u.test(v)) return "Emojis não são permitidos";
      if (/[<>{}[\]\\|^~`]/u.test(v)) return "Caracteres especiais não são permitidos";
      return true;
    },
  },
};
</script>
